/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable sonarjs/no-nested-template-literals */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable react/jsx-curly-brace-presence */

import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Navbar, Nav, NavDropdown, Row, Col, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import superagent from "superagent";
import { toast } from "react-toastify";
import bglogo from "../../assets/images/bglogo.svg";
import ppf from "../../assets/images/icons/ppf.svg";
import { getIsProMember, getPaymentHistory } from "../../containers/account/actions";
import { logoutAction } from "../../containers/login/actions";
import "./style.scss";
import Login from "./login";
import CheckOutsidClick from "../../utils/CheckOutsidClick";
import { useCalculatorsHook } from "./calculatorLinks";
import BlogMegaMenu from "./blogMegaMenu";
import { getBlogCtegoryAndSubcategory } from "../../containers/home/actions";
import RightBlogs from "./rightMenu/RightBlogs";
import { base_url } from "../../utils/constants";
import ProModal from "../ProModal";
import { GET_ACCOUNT_DATA_LOADER, GET_ACCOUNT_LOADER } from "../../containers/account/constants";
import MobileLoginModal from "./MobileLoginModal";
import { getActiveAnnouncement } from "../../containers/admin/addAnnouncement/redux/selectors";
import AnnouncementBar from "./AnnouncementBar";
import useShowAnnouncement from "./hooks/useShowAnnouncement";
import { SHOW_ANNOUNCEMENT } from "../../containers/admin/addAnnouncement/redux/constants";
import { getSettingUserData } from "../setting/services/action/getAction";
import { progressNoteGenerator, calculatorAndToolsSlugs, calculatorAndToolsName, calculatorAndToolsResoucesLandingSlugs } from "../../utils/commonRouteUrl";
import ProfileSection from "./ProfileSection";
import useLeftMenuOptions from "./hooks/useLeftMenuOptions";
import CustomButton from "../Buttons/CustomButton";
import LeftMenuSection from "./LeftMenuSection";
import LogoImage from "./LogoImage";
import useMobile from "../../hooks/useMobile";
import SearchFeature from "../searchFeature";
// import { removeTrailingSlashes } from "../../utils/commonFunctions";

const cookie = new Cookies();

// eslint-disable-next-line sonarjs/cognitive-complexity
function Header(props) {
  const [helpers, setHelpers] = useState("");
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const user_token = cookie.get("user_token");

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const user_info = useSelector((state) => state?.my_account?.user_info);
  const activeAnnouncement = useSelector(getActiveAnnouncement);

  const liveAnnouncement = useMemo(() => !!(activeAnnouncement?.announcement && activeAnnouncement?.date && activeAnnouncement?.time), [activeAnnouncement]);
  const isMobile = useMobile(767);
  const [
    optimizeCalculator,
    goodFaithCalculator,
    outOfNetworkCalculator,
    optimizeRightCalculator,
    goodFaithRightCalculator,
    outOfNetworkRightCalculator,
    practicePaperwork,
    superbill,
  ] = useCalculatorsHook(user_token, user_info);
  const [openRightMenu, setOpenRightMenu] = React.useState(false);
  const [showResourcesMenu, setShowResourcesMenu] = React.useState(false);
  const [showCalculatorMenu, setShowCalculatorMenu] = React.useState(false);
  const [showCategoriesMenu, setShowCategoriesMenu] = React.useState(false);
  const [showResourceTypeMenu, setShowResourceTypeMenu] = React.useState(false);
  const [showCommunitiesMenu, setShowCommunitiesMenu] = React.useState(false);
  const [showInsuranceMenu, setShowInsuranceMenu] = React.useState(false);
  const [showMembershipMenu, setShowMembershipMenu] = React.useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [proMonthUpgradeModal, setProMonthUpgradeModal] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [showResources, setShowResources] = useState(false);
  const [showCommunity, setShowCommunity] = useState(false);
  const [showInsurance, setShowInsurance] = useState(false);
  const [showMembership, setShowMembership] = useState(false);
  const [showMobileDropdown, setShwoMobileDropdown] = useState(false);
  const [showBlogMenu, setShowBlogMenu] = useState(false);
  const [showCategoryMenu, setShowCategoryMenu] = useState(false);
  const [, setShowToggle] = useState(false);
  const [activeMenu, setActiveMenu] = useState(`${location.pathname}${location.search || ""}`);
  const [showDropdown, setShwoDropdown] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [blogHover, _setBlogHover] = useState(false);
  const [headClass, setHeadClass] = useState("");
  const setBlogHover = useCallback(() => _setBlogHover(true), []);
  const resetBlogHover = useCallback(() => _setBlogHover(false), []);
  const params = new URLSearchParams(document.location.search.substring(1));
  const redirectUrl = params.get("redirect_url");
  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname, search } = location;
  const routeUrlWithQuery = useMemo(() => {
    return pathname + search;
  }, [pathname, search]);

  const hasTrailingSlash = useMemo(() => {
    return routeUrlWithQuery.endsWith("/");
  }, [routeUrlWithQuery]);

  // useEffect(() => {
  //   if (hasTrailingSlash && pathname !== "/") {
  //     history?.push(removeTrailingSlashes(routeUrlWithQuery));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  console.log(hasTrailingSlash);
  useLeftMenuOptions();

  const closeMegaMenu = useCallback(() => {
    setShowResources(false);
    setShowCommunity(false);
    setShowInsurance(false);
    setShowMembership(false);
    setShowAbout(false);
    setIsSidebarOpen(false);
  }, [setShowAbout, setShowMembership, setShowResources, setShowCommunity, setShowInsurance]);

  useEffect(() => {
    const handleEvent = (event) => {
      // Close the menu on route change or mouse leaving window
      if (event.type === "popstate" || event.type === "mouseleave") {
        closeMegaMenu();
      }
    };

    // Add event listener for route changes and mouse leaving window
    window.addEventListener("popstate", handleEvent);
    window.addEventListener("mouseleave", handleEvent);

    return () => {
      // Clean up event listeners on component unmount
      window.removeEventListener("popstate", handleEvent);
      window.removeEventListener("mouseleave", handleEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array

  useEffect(() => {
    if (cookie.get("user_token")) {
      dispatch({ type: GET_ACCOUNT_DATA_LOADER, payload: true });
      dispatch({ type: GET_ACCOUNT_LOADER, payload: true });
      setTimeout(() => {
        dispatch({ type: GET_ACCOUNT_LOADER, payload: false });
      }, 3000);
      dispatch(getSettingUserData());
    }
  }, [dispatch]);

  useEffect(() => {
    setActiveMenu(`${location.pathname}${location.search || ""}`);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (user_info.auth_token) {
      cookie.set("user_info", user_info, {
        path: "/",
        expires: new Date(Date.now() + 3600 * 1000 * 24),
      });
    }
  }, [user_info]);

  const helper = document.getElementById("helper")?.offsetTop;
  useEffect(() => {
    setHelpers(helper);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [helpers]);

  const handleClickLogout = () => {
    dispatch(logoutAction(history));
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    if (cookie.get("user_token")) {
      dispatch({ type: GET_ACCOUNT_DATA_LOADER, payload: true });
      dispatch(getSettingUserData());
    }
  }, [dispatch]);

  useEffect(() => {
    if (cookie.get("user_token")) {
      if (user_info?.id) {
        dispatch(getIsProMember(user_info?.id));

        if (user_info?.is_free_trial === 1) {
          dispatch({ type: GET_ACCOUNT_DATA_LOADER, payload: false });
        }
      }
    } else {
      dispatch({ type: GET_ACCOUNT_DATA_LOADER, payload: false });
    }
    dispatch(getBlogCtegoryAndSubcategory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user_info?.id]);

  useEffect(() => {
    if (cookie.get("user_token")) {
      dispatch(getPaymentHistory("?paginate=100&page=1"));
    }
  }, [dispatch]);

  const closeLeftRightMenu = useCallback(() => {
    setIsSidebarOpen(false);
    setOpenRightMenu(false);
  }, []);

  const onClickResources = () => {
    closeLeftRightMenu();
    if (!showResources) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      history.push("/resources");
    }
  };

  const onClickCommunities = () => {
    closeLeftRightMenu();
    if (!showCommunitiesMenu) {
      history.push("/community");
    }
  };
  const onClickInsurance = () => {
    closeLeftRightMenu();
    if (!showInsuranceMenu) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      history.push("/insurance");
    }
  };

  const onClickMembership = () => {
    closeLeftRightMenu();
    if (!showMembershipMenu) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      history.push("/membership");
    }
  };

  const handleFreeTrial = useCallback(() => {
    if (user_info?.auth_token && !user_info?.email_verified_at) {
      history.push("/confirm-email");
      toast.error("Please verify email");
    } else {
      superagent
        .get(`${base_url}trial-subscription?plan=PRO&type=free-trial`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          window.location = res.body.url;
        });
    }
  }, [history, user_info?.auth_token, user_info?.email_verified_at]);

  const blogData = useSelector((state) => state?.home?.blog_category_subcategory);

  // eslint-disable-next-line consistent-return, sonarjs/cognitive-complexity
  const freeTrial = useMemo(() => {
    // eslint-disable-next-line prettier/prettier
    if (
      user_token &&
      ((user_info?.subscription_type !== "PRO_MONTH" &&
        user_info?.subscription_type !== "PRO" &&
        user_info?.is_free_trial === 0 &&
        user_info?.type !== "trial" &&
        user_info?.is_pro === 0) ||
        // eslint-disable-next-line eqeqeq
        (!user_info?.email_verified_at && user_info?.is_free_trial === 0 && user_info?.is_pro == 0))
    ) {
      return (
        // eslint-disable-next-line react/jsx-filename-extension
        <div className="text-center pe-3 d-flex align-items-center justify-content-center">
          <CustomButton
            variant="highlight-solid"
            gradient
            onClick={() => {
              handleFreeTrial();
            }}
          >
            Try Pro for free
          </CustomButton>
        </div>
      );
    }
    if (
      (user_token &&
        (user_info?.subscription_type === "PRO" ||
          user_info?.subscription_type === "PRO_MONTH" ||
          (user_info?.is_pro === true &&
            user_info?.subscription_type !== "BASIC" &&
            user_info?.subscription_type !== "PREMIUM" &&
            user_info?.subscription_type !== "PREMIUM_MONTH"))) ||
      ((user_info?.subscription_type === "PRO" || user_info?.subscription_type === "PRO_MONTH") &&
        user_info?.type === "subscription" &&
        user_info?.plan_expired === 1)
    ) {
      return (
        <div className="text-center pe-3 d-flex align-items-center justify-content-center">
          <CustomButton
            variant="highlight"
            type="submit"
            gradient
            onClick={() => {
              history.push({
                pathname: "/dashboard",
                state: "inviteFriend",
              });
            }}
          >
            Invite Friends
          </CustomButton>
        </div>
      );
    }
    if (
      user_token &&
      (((user_info?.plan_expired === 0 || user_info?.plan_expired === 1) &&
        user_info?.type !== "trial" &&
        user_info?.subscription_type !== "PRO" &&
        user_info?.subscription_type !== "PRO_MONTH" &&
        user_info?.is_pro === true) ||
        (user_info?.subscription_type === "BASIC" && user_info?.is_free_trial === 1 && user_info?.plan_expired === 0))
    ) {
      return (
        <div className="text-center pe-3 d-flex align-items-center justify-content-center">
          <CustomButton
            variant="highlight-solid"
            type="submit"
            gradient
            onClick={() => {
              setProMonthUpgradeModal(true);
            }}
          >
            Upgrade to Pro
          </CustomButton>
        </div>
      );
    }
  }, [
    user_token,
    user_info?.subscription_type,
    user_info?.is_free_trial,
    user_info?.type,
    user_info?.is_pro,
    user_info?.email_verified_at,
    user_info?.plan_expired,
    handleFreeTrial,
    history,
  ]);

  // ACTIVE RIGHT  MENU CLASS
  const openShowRightMenuClass = openRightMenu ? "show-menu" : "";
  const openRightMenuClassName = openRightMenu ? "d-none" : "d-block";
  const openMobileRightMenuClassName = isMobileSidebarOpen ? "d-none" : "d-block";
  const openRightMenuOppositeClassName = openRightMenu ? "d-block" : "d-none";
  const openMObileRightMenuOppositeClassName = isMobileSidebarOpen ? "d-block" : "d-none";
  const showRightResourceMenu = showResourcesMenu ? "show" : "";
  const showRightCalculatorMenu = showCalculatorMenu ? "show" : "";
  const showRightCategoriesMenu = showCategoriesMenu ? "show" : "";
  const showRightResourceTypeMenu = showResourceTypeMenu ? "show" : "";
  const showRightCommunitiesMenu = showCommunitiesMenu ? "show" : "";
  const showRightInsuranceMenu = showInsuranceMenu ? "show" : "";
  const showRightMembershipMenu = showMembershipMenu ? "show" : "";

  const blogHoverClassName = blogHover ? "d-block" : "d-none";

  // ACTIVE MOBILE VIEW CLASS
  const isMobileClass = isMobile ? "d-none" : "";

  // ACTIVE ROUTE CLASS
  const activeClass = useMemo(
    () => (path) => {
      return activeMenu === path ? "active" : "";
    },
    [activeMenu],
  );
  const isAboutActive = activeMenu === "/about" ? "active" : "";
  const isResouceActive = activeMenu === "/resources" ? "active" : "";
  const isCommunityActive = activeMenu === "/community" ? "active" : "";
  const isInsuranceActive = activeMenu === "/insurance" ? "active" : "";
  const isMembershipActive = activeMenu === "/membership" ? "active" : "";
  const isUserProUrl = useMemo(
    () =>
      user_info?.subscription_type === "PRO" || user_info?.subscription_type === "PRO_MONTH" || user_info?.role === "Admin"
        ? `${progressNoteGenerator}`
        : calculatorAndToolsResoucesLandingSlugs.therapyNotesGenerator(),
    [user_info?.role, user_info?.subscription_type],
  );

  const { className } = props;

  useEffect(() => {
    dispatch({ type: SHOW_ANNOUNCEMENT, payload: showAnnouncement });
  }, [dispatch, showAnnouncement]);

  useShowAnnouncement(setShowAnnouncement, user_info, user_token);
  const redirectTo = useMemo(() => {
    return redirectUrl ? `?redirect_url=${encodeURIComponent(redirectUrl)}` : "";
  }, [redirectUrl]);

  useLeftMenuOptions();

  const closeRightMenu = () => {
    setOpenRightMenu(false);
    setShowResourcesMenu(false);
    setShowCalculatorMenu(false);
    setShowInsuranceMenu(false);
    setShowMembershipMenu(false);
    setShowCommunitiesMenu(false);
    setShowBlogMenu(false);
    setShowCategoryMenu(false);
  };
  return (
    <>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {showAnnouncement && liveAnnouncement && (
        <AnnouncementBar activeAnnouncement={activeAnnouncement} setShowAnnouncement={setShowAnnouncement} loggedIn={user_token} />
      )}
      <header className={`${className} header-area`}>
        <LogoImage isAuth={user_token !== undefined} closeRightMenu={closeRightMenu} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

        {!user_token && (
          <Navbar expand="xl" className="position-static p-0 align-items-stretch">
            <Navbar.Collapse id="navbar-dark-example">
              <Nav className="align-items-stretch h-100">
                <NavDropdown
                  onToggle={() => {
                    history.push("/about");
                  }}
                  id="about"
                  className={isAboutActive}
                  title="About"
                  show={showAbout}
                  onMouseEnter={() => setShowAbout(true)}
                  onMouseLeave={() => setShowAbout(false)}
                >
                  <div className={`d-flex justify-content-center ${showAbout ? "" : "d-none"}`}>
                    <div
                      className="p-4 rounded-bottom overflow-hidden dropShadow position-relative"
                      style={{ background: "linear-gradient(90deg, #FB761C 0%, #B962C3 52.7%, #5198EF 94.27%)", width: "440px" }}
                    >
                      <h5 className="text-white">Made for therapists, by therapists</h5>

                      <Link to="/about" className="mt-3 d-block">
                        <CustomButton variant="rainbow" type="submit" gradient>
                          Learn More
                        </CustomButton>
                      </Link>
                      <img className="bg-logo" src={bglogo} alt="bgLogo" />
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown
                  onToggle={() => {
                    history.push("/resources");
                  }}
                  id="resources"
                  className={`megaMenu ${isResouceActive}`}
                  title="Resources"
                  menuVariant="light"
                  show={showResources}
                  onMouseEnter={() => setShowResources(true)}
                  onMouseLeave={() => setShowResources(false)}
                >
                  <div className={`d-flex justify-content-center ${showResources ? "" : "d-none"}`}>
                    <Container className="bg-white rounded-bottom d-flex justify-content-center dropShadow px-0 mx-3">
                      <div className="d-block w-100">
                        <Row className="p-4">
                          <Col xs={8}>
                            <Row>
                              <h6 className="text-primary text-lg mb-3">Private Practice Toolbox</h6>
                              <Col xs={6}>
                                <ul>
                                  <li className="mb-3">
                                    <a
                                      className="d-inline-block ps-4 me-2 position-relative"
                                      href={`${
                                        user_token !== undefined && user_info?.auth_token !== undefined
                                          ? `${isUserProUrl}`
                                          : calculatorAndToolsResoucesLandingSlugs.therapyNotesGenerator()
                                      }`}
                                    >
                                      <i className="fa-fw fa-light start-0 fa-file-zipper position-absolute mt-1 text-primary" />{" "}
                                      {calculatorAndToolsName.therapyNotesGeneratorName()}
                                    </a>
                                  </li>
                                  <li className="mb-3">
                                    <a href={practicePaperwork} className="d-inline-block ps-4 me-2 position-relative">
                                      <img src={ppf} alt="icon" height="19" width="19" className="start-0 position-absolute mt-1 text-primary" />
                                      {calculatorAndToolsName.paperworkAndFormGeneratorName()}
                                    </a>
                                  </li>
                                  <li className="mb-3">
                                    <a href={superbill} className="d-inline-block ps-4 position-relative">
                                      <i className="fa-fw fa-light start-0 fa-file-invoice-dollar position-absolute mt-1 text-primary" />
                                      {calculatorAndToolsName.superbillGenerator()}
                                    </a>
                                  </li>

                                  <li className="mb-3">
                                    <a
                                      className="d-inline-block ps-4 position-relative"
                                      href={`${
                                        user_token !== undefined && user_info?.auth_token !== undefined
                                          ? // eslint-disable-next-line sonarjs/no-duplicate-string
                                            calculatorAndToolsSlugs?.sessionFeeCalculator()
                                          : // eslint-disable-next-line sonarjs/no-duplicate-string
                                            calculatorAndToolsResoucesLandingSlugs.sessionFeeCalculator()
                                      }`}
                                    >
                                      <i className="fa-fw fa-light start-0 fa-gem position-absolute mt-1 text-primary" />
                                      {calculatorAndToolsName.sessionFeeCalculatorName()}
                                    </a>
                                  </li>
                                </ul>
                                <a href={calculatorAndToolsSlugs.toolbox} className="text-primary fw-bold">
                                  Access Practice Toolbox
                                  <i className="fa-regular fa-arrow-right ml-2 mt-2" />
                                </a>
                              </Col>
                              <Col xs={6}>
                                <ul>
                                  <li className="mb-3">
                                    <a className="d-inline-block ps-4 position-relative" href={optimizeCalculator}>
                                      <i className="fa-fw fa-light start-0 fa-piggy-bank position-absolute mt-1 text-primary" />{" "}
                                      {calculatorAndToolsName.therapistDeductionsCalculatorName()}
                                    </a>
                                  </li>

                                  <li className="mb-3">
                                    <a className="d-inline-block ps-4 position-relative" href={goodFaithCalculator}>
                                      <i className="fa-fw fa-light start-0 fa-hand-holding-medical position-absolute mt-1 text-primary" />{" "}
                                      {calculatorAndToolsName.goodFaithEstimateCalculatorName()}
                                    </a>
                                  </li>
                                  <li className="mb-3">
                                    <a className="d-inline-block ps-4 position-relative" href={outOfNetworkCalculator}>
                                      <i className="fa-fw fa-light start-0 fa-envelope-open-dollar position-absolute mt-1 text-primary" />{" "}
                                      {calculatorAndToolsName.outOfNetworkCalculatorName()}
                                    </a>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={4}>
                            <Row>
                              <Col className="h-100">
                                <h6 className="text-primary text-lg mb-3">Categories</h6>
                                <ul>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        state: {
                                          megamenu: true,
                                        },
                                        search: "?category=accounting",
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-envelope-open-dollar mr-2" style={{ color: "#59C5AF" }} /> Accounting
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?category=business",
                                        state: {
                                          megamenu: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-bullseye-arrow mr-2" style={{ color: "#59C5AF" }} /> Business
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?category=client_care",
                                        state: {
                                          megamenu: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-hand-holding-heart mr-2" style={{ color: "#6268DC" }} /> Client Care
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?category=marketing",
                                        state: {
                                          megamenu: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-bullhorn mr-2" style={{ color: "#F19EC6" }} /> Marketing
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?category=technology",
                                        state: {
                                          megamenu: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-laptop-mobile mr-2" style={{ color: "#54A7D9" }} /> Technology
                                    </Link>
                                  </li>
                                </ul>
                              </Col>
                              <Col>
                                <h6 className="text-primary text-lg mb-3">Resource Type</h6>
                                <ul>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?resource_type=calculators_tools",
                                        state: {
                                          megamenu1: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-calculator mr-2 text-primary" /> Calculators + Tools
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?resource_type=checklists",
                                        state: {
                                          megamenu1: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-clipboard-list-check mr-2 text-primary" /> Checklists
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?resource_type=forms",
                                        state: {
                                          megamenu1: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-pen-to-square mr-2 text-primary" /> Forms
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?resource_type=how_to_guides",
                                        state: {
                                          megamenu1: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-map-location-dot mr-2 text-primary" /> How-to-Guides
                                    </Link>
                                  </li>
                                  <li className="mb-3">
                                    <Link
                                      to={{
                                        pathname: "/resources",
                                        search: "?resource_type=spreadsheets",
                                        state: {
                                          megamenu1: true,
                                        },
                                      }}
                                    >
                                      <i className="fa-fw fa-light fa-chart-area mr-2 text-primary" /> Spreadsheets
                                    </Link>
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col xs={12} className="px-0">
                            <div
                              className="px-4 py-3 d-flex align-items-center justify-content-between"
                              style={{ background: "linear-gradient(90deg, #FFA34E 0%, #FF81B8 94.27%)", borderRadius: "4px 4px 16px 16px" }}
                            >
                              <h5 className="text-white mb-0">See all of the resources and tools you get as a Pro member</h5>
                              <Link to="/resources" className="d-inlin-block">
                                <CustomButton variant="marketing" type="submit" gradient>
                                  Browse Resources
                                </CustomButton>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Container>
                  </div>
                </NavDropdown>
                <NavDropdown
                  onToggle={() => {
                    history.push("/community");
                  }}
                  className={`position-static ${isCommunityActive}`}
                  title="Community"
                  show={showCommunity}
                  onMouseEnter={() => setShowCommunity(true)}
                  onMouseLeave={() => setShowCommunity(false)}
                >
                  <div className={`d-flex justify-content-center ${showCommunity ? "" : "d-none"}`} id="community">
                    <div className="bg-white rounded-bottom d-flex justify-content-center p-4 dropShadow">
                      <div className="leftSide pr-5 text-nowrap">
                        <ul>
                          <li className="mb-2">
                            <a href="https://community.claritycooperative.com/topics" target="_blank" rel="noopener noreferrer">
                              <i className="fa-fw fa-light fa-comments mr-2 text-primary" /> Explore Forum
                            </a>
                          </li>
                          <li className="mb-2">
                            <a href="https://community.claritycooperative.com/events" target="_blank" rel="noopener noreferrer">
                              <i className="fa-fw fa-light fa-tv-music mr-2 text-primary" /> Attend Live Sessions
                            </a>
                          </li>
                          <li className="mb-2">
                            <a href="https://community.claritycooperative.com/all-groups" target="_blank" rel="noopener noreferrer">
                              <i className="fa-fw fa-light fa-users mr-2 text-primary" /> Join Groups
                            </a>
                          </li>
                          <li className="mb-2">
                            <a href="https://community.claritycooperative.com/feed" target="_blank" rel="noopener noreferrer">
                              <i className="fa-fw fa-light fa-network-wired mr-2 text-primary" /> Join Networks
                            </a>
                          </li>
                          <li className="mb-2">
                            <a href="https://community.claritycooperative.com/members" target="_blank" rel="noopener noreferrer">
                              <i className="fa-fw fa-light fa-handshake-simple mr-2 text-primary" /> Meet Members
                            </a>
                          </li>
                        </ul>
                        <Link to="/upcoming-features" className="text-primary text-lg fw-bold">
                          Vote on Upcoming Features <i aria-hidden className="fa-regular fa-arrow-right ml-2 mt-3" />
                        </Link>
                      </div>
                      <div
                        className="rightSide p-4 rounded-top overflow-hidden position-relative"
                        style={{ background: "linear-gradient(90deg, #4EBDDD 0%, #59BFC5 94.27%)" }}
                      >
                        <h5 className="pr-5 text-white">Network, connect with peers, and get answers to private practice questions</h5>
                        <Link to="/community" className="d-block mt-3">
                          <CustomButton variant="insurance" type="submit" gradient>
                            Access the Community
                          </CustomButton>
                        </Link>
                        <img className="bg-logo" src={bglogo} alt="bgLogo" />
                      </div>
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown
                  onToggle={() => {
                    history.push("/insurance");
                  }}
                  className={`position-static ${isInsuranceActive}`}
                  title="Insurance"
                  align="start"
                  show={showInsurance}
                  onMouseEnter={() => setShowInsurance(true)}
                  onMouseLeave={() => setShowInsurance(false)}
                >
                  <div className={`d-flex justify-content-center ${showInsurance ? "" : "d-none"}`} id="insurance">
                    <div className="bg-white d-flex justify-content-center p-4 dropShadow rounded-bottom">
                      <div className="leftSide pr-5 text-nowrap">
                        <ul>
                          <li className="mb-2">
                            <Link to="/insurance/health-insurance">
                              <i className="fa-fw fa-light fa-shield-plus mr-2" style={{ color: "#80C6F1" }} /> Health Insurance
                            </Link>
                          </li>
                          <li className="mb-2">
                            <Link to="/insurance/dental-insurance">
                              <i className="fa-fw fa-light fa-tooth mr-2" style={{ color: "#80C6F1" }} /> Dental Insurance
                            </Link>
                          </li>
                          <li className="mb-2">
                            <Link to="/insurance/vision-insurance">
                              <i className="fa-fw fa-light fa-eye mr-2" style={{ color: "#80C6F1" }} /> Vision Insurance
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div
                        className="rightSide p-4 rounded-top overflow-hidden position-relative"
                        style={{ background: "linear-gradient(90deg, #7BD9DB 0%, #7ED7EE 94.27%)" }}
                      >
                        <h5 className="pr-5 text-white">View and enroll in a variety of high-quality insurance plans</h5>
                        <Link to="/insurance" className="btn-block mt-3">
                          <CustomButton variant="insurance" type="submit" gradient>
                            View Plans
                          </CustomButton>
                        </Link>
                        <img aria-hidden="true" className="bg-logo" src={bglogo} alt="bgLogo" />
                      </div>
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown
                  onToggle={() => {
                    history.push("/membership");
                  }}
                  id="membership"
                  className={isMembershipActive}
                  title="Membership"
                  align="end"
                  show={showMembership}
                  onMouseEnter={() => setShowMembership(true)}
                  onMouseLeave={() => setShowMembership(false)}
                >
                  <div className={`d-flex justify-content-center ${showMembership ? "" : "d-none"}`}>
                    <div
                      className="p-4 rounded-bottom dropShadow rounded-bottom overflow-hidden position-relative"
                      style={{ background: "linear-gradient(90deg, #AAB0FC 0%, #6647DB 94.27%)", width: "470px" }}
                    >
                      <h5 className="text-white">Unlock your practice potential</h5>
                      <Link to="/membership" className="d-inline-block mt-3">
                        <CustomButton variant="purple" type="submit" gradient>
                          Explore Membership
                        </CustomButton>
                      </Link>
                      <a href="/member-benefits" className="d-inline-block mt-3 ms-2">
                        <CustomButton variant="purple" type="submit" gradient>
                          Exclusive Discounts
                        </CustomButton>
                      </a>
                      <img aria-hidden alt="bglogo" className="bg-logo" src={bglogo} />
                    </div>
                  </div>
                </NavDropdown>
                <div aria-hidden className="megaMenu nav-item dropdown position-static megaDropdown" onMouseEnter={setBlogHover} onMouseLeave={resetBlogHover}>
                  <a className="nav-link" href="/blog">
                    Blog
                  </a>
                  <div className={blogHoverClassName}>
                    {blogHover && <BlogMegaMenu headClass={headClass} setHeadClass={setHeadClass} blogData={blogData} />}
                  </div>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        )}

        <MobileLoginModal showMobileDropdown={showMobileDropdown} setShwoMobileDropdown={setShwoMobileDropdown} isAdmin={false} />
        <div className="d-flex align-items-stretch headerLeft">
          <SearchFeature />
          {freeTrial}
          {user_token !== undefined && user_info?.auth_token !== undefined ? (
            <ProfileSection
              showDropdown={showDropdown}
              setShwoDropdown={setShwoDropdown}
              setShwoMobileDropdown={setShwoMobileDropdown}
              handleClickLogout={handleClickLogout}
              isAdmin={false}
            />
          ) : (
            <>
              <CheckOutsidClick onOutSideClick={setShwoDropdown} event={"click"}>
                <div aria-hidden onMouseEnter={() => setShowToggle(true)} className="dropdown h-100 d-flex align-items-center">
                  <a href={`/login${redirectTo}`}>
                    <span
                      aria-hidden
                      style={{ cursor: "pointer", fontWeight: "bold" }}
                      onMouseEnter={() => {
                        setShwoDropdown(true);
                      }}
                      className="text-primary"
                    >
                      Log In
                    </span>
                  </a>

                  <div
                    className={`dropdown-menu border-0 shadow p-4 p-0 ${showDropdown && "show"} ${isMobileClass}`}
                    style={{ width: "350px", borderRadius: "0 0 20px 20px" }}
                  >
                    <Login />
                  </div>
                </div>
              </CheckOutsidClick>
              {!user_token && !user_info?.auth_token && (
                <div className="text-center ps-2 ps-sm-3 d-flex align-items-center justify-content-center">
                  <a href="/signup?free-trial=true">
                    <CustomButton variant="highlight" gradient>
                      Try Pro for free
                    </CustomButton>
                  </a>
                </div>
              )}
            </>
          )}
          {!user_token && (
            <div
              aria-hidden="true"
              className="align-items-center ms-2 ms-sm-3 d-flex d-xl-none"
              onClick={() => {
                setOpenRightMenu(!openRightMenu);
                setIsSidebarOpen(false);
                setShowResourcesMenu(false);
                setShowCalculatorMenu(false);
                setShowInsuranceMenu(false);
                setShowMembershipMenu(false);
                setShowCommunitiesMenu(false);
                setShowBlogMenu(false);
                setShowCategoryMenu(false);
              }}
            >
              <i className={`fa-solid h6 fa-fw mb-0 fa-bars ${openRightMenuClassName}`} />
              <i className={`fa-solid h6 fa-fw mb-0 fa-xmark ${openRightMenuOppositeClassName}`} />
            </div>
          )}
          {isMobile && user_token && (
            <div
              aria-hidden="true"
              className="align-items-center ms-2 ms-sm-3 d-flex d-md-none"
              onClick={() => {
                setIsMobileSidebarOpen(!isMobileSidebarOpen);
              }}
            >
              <i className={`fa-solid h6 fa-fw mb-0 fa-bars ${openMobileRightMenuClassName}`} />
              <i className={`fa-solid h6 fa-fw mb-0 fa-xmark ${openMObileRightMenuOppositeClassName}`} />
            </div>
          )}
        </div>
      </header>
      {user_token && !isMobile && (
        <LeftMenuSection isAnnouncementBar={showAnnouncement && liveAnnouncement} setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} />
      )}
      {isMobile && user_token && (
        <LeftMenuSection
          isAnnouncementBar={showAnnouncement && liveAnnouncement}
          setIsSidebarOpen={setIsMobileSidebarOpen}
          isSidebarOpen={isMobileSidebarOpen}
          isMobileView
        />
      )}
      {!user_token && (
        <div className={`${openShowRightMenuClass} menu px-2 right-menu`}>
          <ul>
            <li aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
              <Link to="/about">
                <span className={`menu-link ${activeClass("/about")}`}>
                  <span className="menu-title">About</span>
                </span>
              </Link>
            </li>
            <li className="menu-item">
              <span aria-hidden="true" className={`menu-link ${showRightResourceMenu} ${activeClass("/resources")}`}>
                <span aria-hidden="true" onClick={() => onClickResources()} className="menu-title">
                  Resources
                </span>
                <span aria-hidden onClick={() => setShowResourcesMenu(!showResourcesMenu)} className="menu-arrow" />
              </span>
              <div className={`menu-sub menu-sub-accordion ${showRightResourceMenu}`}>
                <div className="menu-item">
                  <span aria-hidden="true" className={`menu-link ${showRightCalculatorMenu}`}>
                    <span className="menu-title">Private Practice Toolbox</span>
                    <span aria-hidden onClick={() => setShowCalculatorMenu(!showCalculatorMenu)} className="menu-arrow" />
                  </span>
                  <div className={`menu-sub menu-sub-accordion ${showRightCalculatorMenu}`}>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <a
                        className={`menu-link ${activeClass(progressNoteGenerator)}`}
                        href={`${
                          user_token !== undefined && user_info?.auth_token !== undefined
                            ? `${isUserProUrl}`
                            : calculatorAndToolsResoucesLandingSlugs.therapyNotesGenerator()
                        }`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title mr-2">{calculatorAndToolsName.therapyNotesGeneratorName()}</span>
                      </a>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <div className="menu-item">
                        <a href={practicePaperwork} className={`menu-link ${activeClass("/practice-paperwork")}`}>
                          <span className="menu-bullet">
                            <span className="bullet bullet-dot" />
                          </span>
                          <span className="menu-title mr-2">Private Practice Form Library + Generator</span>
                        </a>
                      </div>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <div className="menu-item">
                        <a href={superbill} className={`menu-link ${activeClass(superbill)}`}>
                          <span className="menu-bullet">
                            <span className="bullet bullet-dot" />
                          </span>
                          <span className="menu-title mr-2">{calculatorAndToolsName?.superbillGenerator()}</span>
                        </a>
                      </div>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <a className={`menu-link ${activeClass(calculatorAndToolsSlugs.therapistDeductionsCalculator())}`} href={optimizeRightCalculator}>
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{calculatorAndToolsName.therapistDeductionsCalculatorName()}</span>
                      </a>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <a
                        className={`menu-link ${activeClass(calculatorAndToolsSlugs?.sessionFeeCalculator())}`}
                        href={`${
                          user_token !== undefined && user_info?.auth_token !== undefined
                            ? calculatorAndToolsSlugs?.sessionFeeCalculator()
                            : calculatorAndToolsResoucesLandingSlugs.sessionFeeCalculator()
                        }`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{calculatorAndToolsName.sessionFeeCalculatorName()}</span>
                      </a>
                    </div>
                    <div className="menu-item">
                      <a className={`menu-link ${activeClass(calculatorAndToolsSlugs.goodFaithEstimateCalculator())}`} href={goodFaithRightCalculator}>
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{calculatorAndToolsName.goodFaithEstimateCalculatorName()}</span>
                      </a>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <a className={`menu-link ${activeClass(calculatorAndToolsSlugs.outOfNetworkCalculator())}`} href={outOfNetworkRightCalculator}>
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">{calculatorAndToolsName.outOfNetworkCalculatorName()}</span>
                      </a>
                    </div>

                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <a aria-hidden className={`menu-link fw-bold ${activeClass("/toolbox")}`} href="/toolbox">
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Access Practice Toolbox</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="menu-item">
                  <span aria-hidden="true" className={`menu-link ${showRightCategoriesMenu}`}>
                    <span className="menu-title">Categories</span>
                    <span aria-hidden onClick={() => setShowCategoriesMenu(!showCategoriesMenu)} className="menu-arrow" />
                  </span>
                  <div className={`menu-sub menu-sub-accordion ${showRightCategoriesMenu}`}>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?category=accounting",
                          state: {
                            megamenu: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?category=accounting")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Accounting</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?category=business",
                          state: {
                            megamenu: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?category=business")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Business</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className={`menu-item ${activeClass("/resources?category=client_care")}`}>
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?category=client_care",
                          state: {
                            megamenu: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?category=client_care")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Client Care</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?category=marketing",
                          state: {
                            megamenu: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?category=marketing")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Marketing</span>
                      </Link>
                    </div>
                    <div onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?category=technology",
                          state: {
                            megamenu: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?category=technology")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Technology</span>
                      </Link>
                    </div>
                  </div>
                </div>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <span aria-hidden="true" className={`menu-link ${showRightResourceTypeMenu}`}>
                    <span className="menu-title">Resource Type</span>
                    <span aria-hidden onClick={() => setShowResourceTypeMenu(!showResourceTypeMenu)} className="menu-arrow" />
                  </span>
                  <div className={`menu-sub menu-sub-accordion ${showRightResourceTypeMenu}`}>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?resource_type=calculators_tools",
                          state: {
                            megamenu1: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?resource_type=calculators_tools")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Calculators + Tools</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?resource_type=checklists",
                          state: {
                            megamenu1: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?resource_type=checklists")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Checklists</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?resource_type=forms",
                          state: {
                            megamenu1: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?resource_type=forms")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Forms</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?resource_type=how_to_guides",
                          state: {
                            megamenu1: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?resource_type=how_to_guides")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">How To Guides</span>
                      </Link>
                    </div>
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      <Link
                        to={{
                          pathname: "/resources",
                          search: "?resource_type=spreadsheets",
                          state: {
                            megamenu1: true,
                          },
                        }}
                        className={`menu-link ${activeClass("/resources?resource_type=spreadsheets")}`}
                      >
                        <span className="menu-bullet">
                          <span className="bullet bullet-dot" />
                        </span>
                        <span className="menu-title">Spreadsheets</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="menu-item">
              <span aria-hidden="true" className={`menu-link ${showRightCommunitiesMenu} ${activeClass("/community")}`}>
                <span aria-hidden="true" onClick={() => onClickCommunities()} className="menu-title">
                  Community
                </span>
                <span aria-hidden="true" onClick={() => setShowCommunitiesMenu(!showCommunitiesMenu)} className="menu-arrow" />
              </span>
              <div className={`menu-sub menu-sub-accordion ${showRightCommunitiesMenu}`}>
                <div className="menu-item">
                  <a href="https://community.claritycooperative.com/topics" target="_blank" rel="noopener noreferrer" className="menu-link">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Explore Form</span>
                  </a>
                </div>

                <div className="menu-item">
                  <a href="https://community.claritycooperative.com/events" target="_blank" rel="noopener noreferrer" className="menu-link">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Attend Live Session</span>
                  </a>
                </div>
                <div className="menu-item">
                  <a href="https://community.claritycooperative.com/all-groups" target="_blank" rel="noopener noreferrer" className="menu-link">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Join Groups</span>
                  </a>
                </div>
                <div className="menu-item">
                  <a href="https://community.claritycooperative.com/feed" target="_blank" rel="noopener noreferrer" className="menu-link">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Connect + Networks</span>
                  </a>
                </div>
                <div className="menu-item">
                  <a href="https://community.claritycooperative.com/members" target="_blank" rel="noopener noreferrer" className="menu-link">
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Meet Members</span>
                  </a>
                </div>
              </div>
            </li>
            <li className="menu-item">
              <span aria-hidden="true" className={`menu-link ${showRightInsuranceMenu} ${activeClass("/insurance")}`}>
                <span aria-hidden="true" onClick={() => onClickInsurance()} className="menu-title">
                  Insurance
                </span>
                <span aria-hidden onClick={() => setShowInsuranceMenu(!showInsuranceMenu)} className="menu-arrow" />
              </span>
              <div className={`menu-sub menu-sub-accordion ${showRightInsuranceMenu}`}>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <Link to="/insurance/health-insurance" className={`menu-link ${activeClass("/insurance/health-insurance")}`}>
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Health Insurance</span>
                  </Link>
                </div>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <Link to="/insurance/dental-insurance" className={`menu-link ${activeClass("/insurance/dental-insurance")}`}>
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Dental Insurance</span>
                  </Link>
                </div>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <Link to="/insurance/vision-insurance" className={`menu-link ${activeClass("/insurance/vision-insurance")}`}>
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Vision Insurance</span>
                  </Link>
                </div>
              </div>
            </li>
            <li className="menu-item">
              <span aria-hidden="true" className={`menu-link ${showRightMembershipMenu} ${activeClass("/membership")}`}>
                <span aria-hidden="true" onClick={() => onClickMembership()} className="menu-title">
                  Membership
                </span>
                <span aria-hidden onClick={() => setShowMembershipMenu(!showMembershipMenu)} className="menu-arrow" />
              </span>
              <div className={`menu-sub menu-sub-accordion ${showRightMembershipMenu}`}>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <Link to="/membership" className={`menu-link ${activeClass("/membership")}`}>
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Explore Membership</span>
                  </Link>
                </div>
                <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                  <a href="/member-benefits" className={`menu-link ${activeClass("/member-benefits")}`}>
                    <span className="menu-bullet">
                      <span className="bullet bullet-dot" />
                    </span>
                    <span className="menu-title">Exclusive Discounts</span>
                  </a>
                </div>
              </div>
            </li>
            <RightBlogs
              showBlogMenu={showBlogMenu}
              setShowBlogMenu={setShowBlogMenu}
              showCategoryMenu={showCategoryMenu}
              setShowCategoryMenu={setShowCategoryMenu}
              closeLeftRightMenu={closeLeftRightMenu}
            />
          </ul>

          {proMonthUpgradeModal && (
            <ProModal
              isOpen={proMonthUpgradeModal}
              onClosed={() => setProMonthUpgradeModal(false)}
              title="Unlock Pro Features"
              content="Do you like what you’ve experienced so far? Unlock more potential:"
              price="$19.99"
              Flag="Month"
              submitBtn
              isFreeTrial={false}
              monthly={isMonthly}
              setMonthly={setIsMonthly}
            />
          )}
        </div>
      )}
      {proMonthUpgradeModal && (
        <ProModal
          isOpen={proMonthUpgradeModal}
          onClosed={() => setProMonthUpgradeModal(false)}
          title="Unlock Pro Features"
          content="Do you like what you’ve experienced so far? Unlock more potential:"
          price="$19.99"
          Flag="Month"
          submitBtn
          isFreeTrial={false}
          monthly={isMonthly}
          setMonthly={setIsMonthly}
        />
      )}
    </>
  );
}

export default withRouter(Header);
